import React, { useEffect } from "react";
import styles from "./IncomingCourses.module.css";
import { Carousel } from "primereact/carousel";

const IncomingCourses = (props) => {
  const getDate = (date) => {
    const dateParts = date.split("-");

    const courseStartDate = new Date(
      dateParts[2] + "-" + dateParts[0] + "-" + dateParts[1]
    );
    const today = new Date();

    return courseStartDate >= today;
  };
  
  const incomingCourses = props.courses.filter(
    (course) => course.status === true && getDate(course.startDate)
  );
  // const incomingCourses = props.courses


  const responsiveOptions = [
    {
      breakpoint: "1400px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "1199px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "425px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "325px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  const courseTemplate = (course) => {
    return (
      <div className={styles.incomingCourses}>
        <div className={styles.infoBox}>
          <h1 className={styles.subTitle}>{"Próximos cursos"}</h1>

          <h1 className={styles.Title}>{course.topic}</h1>
          <button
            onClick={() => (window.location.href = `/courseinfo/${course.id}`)}
            className={styles.button}
          >
            {"Más información"}
          </button>
        </div>
        <div className={styles.imageContainer}>
          <img
            src={course.imageUrl}
            alt="Course image"
            className={styles.image}
          />
        </div>
      </div>
    );
  };
  return (
    <Carousel
      value={incomingCourses}
      itemTemplate={courseTemplate}
      numVisible={1}
      numScroll={1}
      // page={1}
      // circular={true}
      className={styles.carousel}
      responsiveOptions={responsiveOptions}
      // autoplayInterval={10000}
    />
  );
};

export default IncomingCourses;
